export default {
  admin: [
    {
      icon: 'fa fa-image',
      label: 'photo.manager',
      route: {
        name: 'admin.photo-manager',
      },
      roles: ['ROLE_ADMIN'],
      create: (getRestrict) => !!getRestrict('photo.manager'),
    },
  ],
}